import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { MarketCashOutState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketCashOut/MarketCashOut.state';
import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export interface MarketCashOutPropsType {
    marketId: MarketId;
}

export const MarketCashOut = observer('MarketCashOut', (propsIn: MarketCashOutPropsType) => {
    const props = useAsObservableSource(propsIn);
    const appState = useAppStateContext();
    const [state] = useState(() => new MarketCashOutState(appState, props));

    const marketModel = props.marketId.getModel();
    if (marketModel === null) {
        return null;
    }

    return (<>
        <h4>Cash out</h4>
        <div className='row'>
            <div className='col-12'>
                <div className='element checkbox' data-test='cash-out-checkbox'>
                    <label>
                        <input type='checkbox' defaultChecked={marketModel.cashoutAvailable} onChange={state.onChangeCashoutAvailable}/>
                        <span>Cash out</span>
                    </label>
                </div>
            </div>
        </div>
        <div className='row'>
            <div className='col-4'>
                <div className={`element hasLabel ${state.baseCashoutError !== null ? 'invalid error' : ''}`} data-test='base-cashout'>
                    <input
                        type='text'
                        name='cashoutMarketSettings.baseCashout'
                        value={state.baseCashout}
                        onChange={state.onChangeBaseCashout}
                        onBlur={state.onSaveBaseCashout}
                    />
                    <label>Base cash out</label>
                    {
                        state.baseCashoutError !== null ?
                            <div className='error-message'>
                                <div className='error-message-content'>{state.baseCashoutError}</div>
                            </div> : null
                    }
                </div>
            </div>
            <div className='col-4'>
                <div className={`element hasLabel ${state.cashoutOverroundError !== null ? 'invalid error' : ''}`} data-test='cash-out-overround'>
                    <input
                        type='text'
                        name='cashoutMarketSettings.cashoutOverround'
                        value={state.cashoutOverround}
                        onChange={state.onChangeCashoutOverround}
                        onBlur={state.onSaveCashoutOverround}
                    />
                    <label>Cash out overround</label>
                    {
                        state.cashoutOverroundError !== null ?
                            <div className='error-message'>
                                <div className='error-message-content'>{state.cashoutOverroundError}</div>
                            </div> : null
                    }
                </div>
            </div>
            <div className='col-4'>
                <div className={`element hasLabel ${state.cashoutOfferEasingError !== null ? 'invalid error' : ''}`} data-test='cash-out-offer-easing'>
                    <input
                        type='text'
                        name='cashoutMarketSettings.cashoutOfferEasing'
                        value={state.cashoutOfferEasing}
                        onChange={state.onChangeCashoutOfferEasing}
                        onBlur={state.onSaveCashoutOfferEasing}
                    />
                    <label>Cash out offer easing</label>
                    {
                        state.cashoutOfferEasingError !== null ?
                            <div className='error-message'>
                                <div className='error-message-content'>{state.cashoutOfferEasingError}</div>
                            </div> : null
                    }
                </div>
            </div>
        </div>
    </>);
});
